import React, { useState } from 'react';
import axios from 'axios';

const API_URL = 'https://broadcastbackend.onrender.com/api';

export default function AdminLogin({ onLoginSuccess }) {
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await axios.post(`${API_URL}/admin/login`, { password });
      if (response.data.success) {
        localStorage.setItem('adminLoggedIn', 'true');
        onLoginSuccess();
      }
    } catch (err) {
      setError('Invalid password');
      setPassword('');
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-modal">
      <div className="admin-login-content">
        <div className="admin-login-header">
          <h2>🔐 Admin Panel</h2>
          <p>Enter password to access</p>
        </div>

        {error && <div className="admin-login-error">{error}</div>}

        <form onSubmit={handleSubmit} className="admin-login-form">
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              placeholder="Enter admin password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoFocus
            />
          </div>

          <button type="submit" disabled={loading} className="admin-login-btn">
            {loading ? 'Authenticating...' : 'Access Admin Panel'}
          </button>
        </form>
      </div>
    </div>
  );
}
